import React from 'react';
import { Formik } from 'formik';
import LinearGradientButton from '../../components/styled/LinearGradientButton';
import TextInput from '../../components/styled/TextInput';
import Text from '../../components/styled/Text';
import View from '../../components/styled/View';
import styles from './styles';
import { artistCreateProfileSchema } from './validationSchema';

export default function ArtistProfile({ navigation }) {
  const goToCreateSession = (values) => {
    navigation.navigate('ArtistGenres', {
      isCreate: true,
      formikValues: values,
    });
  };
  return (
    <View style={styles.container}>
      <Text style={styles.title}> Create Your Profile </Text>
      <Formik
        initialValues={{
          artistName: '',
          hometown: '',
          bio: '',
        }}
        onSubmit={(values) => goToCreateSession(values)}
        validationSchema={artistCreateProfileSchema}
      >
        {({
          errors,
          handleChange,
          handleBlur,
          handleSubmit,
          isValid,
          touched,
          values,
        }) => (
          <>
            <View style={{ width: 200 }}>
              <TextInput
                autoCapitalize="none"
                autoCompleteType="off"
                errorMessage={touched.artistName && errors.artistName}
                keyboardType="default"
                label="Artist Name*"
                labelHidden
                onBlur={handleBlur('artistName')}
                onChangeText={handleChange('artistName')}
                placeholder="Artist Name"
                value={values.artistName}
              />
              <TextInput
                autoCompleteType="off"
                autoCapitalize="none"
                autoCorrect
                errorMessage={touched.hometown && errors.hometown}
                keyboardType="default"
                label="Hometown*"
                labelHidden
                onBlur={handleBlur('hometown')}
                onChangeText={handleChange('hometown')}
                placeholder="Hometown"
                value={values.hometown}
              />
              <TextInput
                autoCapitalize="none"
                autoCompleteType="off"
                keyboardType="default"
                label="Bio (optional)"
                labelHidden
                multiline
                numberOfLines={4}
                onBlur={handleBlur('bio')}
                onChangeText={handleChange('bio')}
                placeholder="Biography"
                value={values.bio}
              />
              <LinearGradientButton
                disabled={!isValid}
                title="Choose Genres"
                onPress={handleSubmit}
              />
            </View>
          </>
        )}
      </Formik>
    </View>
  );
}
